export const collaboratorsLocale = {
   title: 'Collaborators',
   code: "referral code",
   link: "link",
   number_people_invited: "number of invited users",
   level: "Level",
   balance_received: "unreceived balance",
   register_withdraw: "register for withdrawal",
   list_user_invite: 'Referred users list',
   search: 'search',
   stt: 'STT',
   time: 'Time',
   mail: 'mail',
   kyc: 'kyc',
   withdrawal_history: 'withdrawal history',
   amount: 'amount',
   token_type: 'Token type',
   status: 'status',
   register_title: 'Register to become a collaborator',
   register_content: "By clicking the confirm button below, you will agree to become AIS's collaborator.",
   confirm_register: 'confirm',
   close_register: 'cancel',
   withdraw_all: 'Withdraw all',
   withdraw_landmark: 'Withdraw by milestone',
   money: 'Amount',
   money_remaining: 'Remaining',
   withdrawal_fee: 'Withdrawal fee',
   bonus_draw_milestone: 'bonus draw milestone (referrer)',
   withdraw_content: 'Users can choose to withdraw based on current level or full amount earned. When withdrawing, the level and number of referrals will be reset. Full withdrawal will incur a fee of 2000 STN-A.',
   unknown_error: 'Something went wrong please try again later',
   oops: 'Oops!',
   ok: 'OK',
};
